export interface HasId {
  id: string;
}

export interface BaseModel extends HasId {
  created: number;
  updated: number;
}

export interface RedirectToken {
  token: string;
  expiry: number;
  type: string;
  entityId: string;
}

export interface QueryParams {
  page: number;
  pageSize?: number;
  searchQuery?: string;
  ascending: boolean;
}

export enum EQuoteType {
  Other = "Other",
  Boiler = "Boiler",
  BoilerSolar = "BoilerSolar",
  Solar = "Solar",
  Insulation = "Insulation",
  HeatPump = "HeatPump",
  EvCharger = "EvCharger"
}

export enum EQuotePurchaserType {
  Home = "Home",
  Business = "Business",
  Farm = "Farm"
}

export interface Count {
  count: number;
}

export enum PageState {
  Ready = "Ready",
  Loading = "Loading",
  Error = "Error"
}

export interface Account extends HasId {
  name: string;
  firstName: string;
  lastName: string;
  mobilePhone: string;
  email: string;
  addresses: Address[];
  externalIds: ExternalId[];
}

export interface ExternalId {
  serviceName: string;
  serviceIds: string[];
}

export interface User extends HasId {
  name: string;
  mobilePhone: string;
  email: string;
  location: string;
  firstName: string;
  lastName: string;
  homePhone: string | null;
  photoUrl: string | null;
}

export interface Address extends HasId {
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  townCity: string;
  county: string;
  postCode?: string;
}

export interface Review {
  name: string;
  stars: number;
  description: string;
  timestamp: number;
}

export interface EmailRequest {
  emailAddress: string;
  name: string;
  comments?: string;
  templateId: string;
  file?: File | null;
  [key: string]: any;
  sendQuotePdf?: boolean;
  amount?: number | null;
}

export interface Template {
  id: string;
  name: string;
  subject: string;
  htmlContent: string;
  type: ETemplateType;
}

export enum ETemplateType {
  Boiler = "Boiler",
  Solar = "Solar",
  BoilerSolar = "BoilerSolar",
  Payment = "Payment"
}

export interface IErrors {
  [key: string]: string;
}

export enum EProductType {
  Product = "Product",
  Addon = "Addon"
}

export enum EProductClassification {
  Other = "Other",
  GasBoilers = "GasBoilers",
  Cylinder = "Cylinder",
  GasFlueExtensions = "GasFlueExtensions",
  Alarm = "Alarm",
  BoilerCondensate = "BoilerCondensate",
  PipesCables = "PipesCables",
  Radiators = "Radiators",
  Grants = "Grants",
  Electrical = "Electrical",
  Controls = "Controls",
  Immersion = "Immersion",
  OilFlueExtensions = "OilFlueExtensions",
  OilBoilers = "OilBoilers",
  Plumbing = "Plumbing",
  SolarPV = "SolarPV",
  Inverter = "Inverter",
  Battery = "Battery",
  Powerflush = "Powerflush",
  Maintenance = "Maintenance"
}

export interface Payment {
  status: EPaymentStatus;
  amount: number;
  paymentDate: number;
  type: EPaymentType;
}

export enum EPaymentStatus {
  Unpaid = "Unpaid",
  Paid = "Paid",
  Declined = "Declined",
  ChargeBack = "ChargeBack"
}

export enum EPaymentType {
  Deposit = "Deposit",
  Internal = "Internal",
  Other = "Other"
}

export enum ESubscriptionStatus {
  Pending = "Pending",
  Active = "Active",
  Cancelled = "Cancelled"
}

export const EProductClassificationDescriptions: Array<[EProductClassification, string]> = [
  [
    EProductClassification.Controls,
    "Your engineer has recommended these heating solutions to make your home warmer and more energy efficient."
  ],
  [
    EProductClassification.Powerflush,
    "Flush away any dirt and debris and help prevent your new system from being contaminated and inhibited."
  ],
  [EProductClassification.Cylinder, "Enjoy improved shower and bath performance all year round with a new Cylinder"],
  [
    EProductClassification.Maintenance,
    "We have a cover plan that is hassle free every year and ensures your boiler is running safely and efficiently."
  ]
];

export interface ServerConfig {
  name: string;
  isWhiteLabel: boolean;
  services: Service[];
  settings: Setting[];
}
export interface Service {
  name: string;
  features: Feature[];
  settings: Setting[];
}
export interface Feature {
  name: string;
  enabled: boolean;
  featureConfig: any;
}
export interface Setting {
  name: string;
  value: string;
}
